import { render } from "./CheckBoxes.vue?vue&type=template&id=5211b63b"
import script from "./CheckBoxes.vue?vue&type=script&lang=js"
export * from "./CheckBoxes.vue?vue&type=script&lang=js"
script.render = render

export default script